'use strict';

const createSocialShareLink = (location, thisEle, data) => {
    const winWidth = 520;
    const winHeight = 350;
    const winTop = (screen.height / 2) - (winHeight / 2);
    const winLeft = (screen.width / 2) - (winWidth / 2);

    const locationUrl = location;
    const locationTitle = document.title;
    const socialNetwork = thisEle.firstChild.className.split('--')[1];

    let baseUrlHref, baseUrlText, baseUrlDisplay, baseUrlMedia, shareUrl, shareWindow;

    switch (socialNetwork){
        case 'facebook':
            baseUrlHref = 'u=' + encodeURIComponent(locationUrl);
            baseUrlDisplay = 'display=popup';
            shareUrl = 'https://www.facebook.com/sharer.php?' + baseUrlHref + '&' + baseUrlDisplay;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'twitter':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            baseUrlText = 'text=' + encodeURIComponent(locationTitle);
            shareUrl = 'https://twitter.com/intent/tweet?' + baseUrlText + '&' + baseUrlHref;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'pinterest':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            baseUrlText = 'description=' + encodeURIComponent(locationTitle);
            baseUrlMedia = data ? 'media=' + data.pdpImg : '';
            shareUrl = 'https://pinterest.com/pin/create/link?' + baseUrlHref + '&' + baseUrlText + '&' + baseUrlMedia;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'google':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            shareUrl = 'https://plus.google.com/share?' + baseUrlHref;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'instagram':
            shareUrl = data ? data.url : '';
            location.replace(shareUrl);

            break;
        default:
            break;
    }
};

module.exports = createSocialShareLink;
